"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brescello": {
    "45cad757": [{
      "hkey": "c032c3ff",
      "slug": "lentigione-sorbolo-a-mane",
      "name": "Lentigione-Sorbolo a Mane",
      "primary": true,
      "skipSearch": false
    }],
    "lentigione": [{
      "hkey": "c032c3ff",
      "slug": "lentigione-sorbolo-a-mane",
      "name": "Lentigione-Sorbolo a Mane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d1fc4919": [{
      "hkey": "c032c3ff",
      "slug": "lentigione-sorbolo-a-mane",
      "name": "Lentigione-Sorbolo a Mane",
      "primary": true,
      "skipSearch": false
    }],
    "sorbolo-a-mane": [{
      "hkey": "c032c3ff",
      "slug": "lentigione-sorbolo-a-mane",
      "name": "Lentigione-Sorbolo a Mane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brescello"
    }]
  }
};
exports["default"] = _default;